import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AuthTokenResponse,
  LoginRequest,
  RegisterRequest,
  RegisterResponse,
} from '../models/auth.models';

const OPT = { withCredentials: true };

@Injectable({ providedIn: 'root' })
export class AuthHttpService {
  private readonly http = inject(HttpClient);

  register(body: RegisterRequest): Observable<RegisterResponse> {
    return this.http.post<RegisterResponse>(environment.auth.register, body, OPT);
  }

  login(body: LoginRequest): Observable<AuthTokenResponse> {
    return this.http.post<AuthTokenResponse>(environment.auth.login, body, OPT);
  }

  refreshToken(token: string): Observable<AuthTokenResponse> {
    return this.http.post<AuthTokenResponse>(environment.auth.refresh, { token }, OPT);
  }

  verifyEmail(token: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(environment.auth.verifyEmail, { token }, OPT);
  }

  forgotPassword(email: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(environment.auth.forgotPassword, { email }, OPT);
  }

  resetPassword(body: { token: string; newPassword: string }): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(environment.auth.resetPassword, body, OPT);
  }
}